import React from 'react';
import { Tooltip } from '@mui/material';
import { ModeButton } from './StyledComponents';

/**
 * Reusable toggle mode buttons component
 * Used for switching between submodes (e.g., GAME/MAP in cursor, LINE/AREA in paint)
 */
const ToggleModeButtons = ({ modes, activeMode, onChange }) => {
  return (
    <>
      {modes.map(({ value, label, icon: Icon, tooltip }) => (
        <Tooltip key={value} title={tooltip || label} placement="bottom">
          <ModeButton
            active={activeMode === value}
            onClick={() => onChange?.(value)}
          >
            <Icon />
          </ModeButton>
        </Tooltip>
      ))}
    </>
  );
};

export default ToggleModeButtons;

